export default __webpack_public_path__ + "static/media/a9.130d1111.png";